/************************* Helpers *************************/

let gOverlayLoaded = false;

const createGOverlay = () => {
    const overlay = document.createElement('div');
    overlay.classList.add('gtc:overlay')
    document.body.append(overlay)
    gOverlayLoaded = true;
};

window.getPageContentHtml = async (pageUrl) => {
    try {
        // Get page as JSON to get body_html, to inject in modal/ drawer
        const pageJson = await (
            await fetch(pageUrl + '.json')
                .then(res => res.json()));
        if (pageUrl.includes('policies/')) {
            return pageJson.policy.body;
        } else {
            return pageJson.page.body_html;
  
        }
    } catch (error) {
        console.log('Error: ', error);
        return '';
    }
  };

const getSectionHtml = async (section, canonicalUrl) => {
    try {
        let url = window.location.pathname + '/?sections=' + section;
        if (canonicalUrl) {
            url = new URL(canonicalUrl).pathname + '/?sections=' + section;
        }

        // Get page as JSON to get body_html, to inject in modal/ drawer
        const sectionJson = await (
            await fetch(url)
                .then(res => res.json()));
        return sectionJson[section];
    } catch (error) {
        console.log('Error: ', error);
        return '';
    }
};

/************************* Renders *************************/

const closeText = window.themeVariables?.strings?.close ? window.themeVariables.strings.close : 'close'
const closeButton = `
<button name="Close" class="gtc:close-button" data-gtc-close type="button" title="${ closeText }">
    <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
        <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
    </svg></button>
</button>`

const renderDefaultModal = ({ header, body, footer }) => {

    let headerHTML = ``
    let bodyHtml = ``;
    let footerHtml = ``;

    if (header) {
        headerHTML = `<h4 class="h3">${ header }</h4>`;
    }
    if (body) {
        bodyHtml = `<div class="gtc:modal__container">${ body }</div>`;
    }
    if (footer) {
        footerHtml = `<footer class="gtc:modal__footer"> ${ footer }</footer >`;
    }

    const htmlString = `
        <header class="gtc:modal__header">
            ${ headerHTML }
            ${ closeButton }
        </header>
        ${ bodyHtml }
        ${ footerHtml }`;

    return htmlString;
};


const renderDefaultDrawer = ({ header, body, footer }) => {

    let headerHTML = ``;
    let bodyHtml = ``;
    let footerHtml = ``;

    if (header) {
        headerHTML = `<h3 class="gtc:drawer__title"> ${ header }</h3>`
    }
    if (body) {
        bodyHtml = `<div class="gtc:drawer__body gtc:size-guide__content">${ body }</div>`;
    }
    if (footer) {
        footerHtml = `<footer class="gtc:drawer__footer"> ${ footer }</footer> `
    }

    const htmlString = `
        <header class="gtc:drawer__header">
            ${ headerHTML }
            ${ closeButton }
        </header>
        ${ bodyHtml }
        ${ footerHtml }`;

    return htmlString
}

/************************* GTC Opener *************************/

/**
 * GTC Opener
 *
 * Settings: if the opener contains "data-gtc-close" and "this" is click "this" will close
 */

class GTCOpener extends HTMLElement {
    constructor() {
        super()

        this.main = this

        //Default classes
        this.class = {
            open: 'open',
            close: 'close',
            overlayOpen: 'gtc:overlay-open',
            scrollLock: 'gtc:scroll-lock'
        }

        this.Click = this.Click.bind(this);
        this.Keydown = this.Keydown.bind(this);
    }

    Init() {
        if (this.settings.rendered === true) {
            this.Open();
        } else {
            this.Create();
        }
    }

    AddOpenerEventListeners() {
        document.addEventListener('click', this.Click, false);
        document.addEventListener("keydown", this.Keydown, false);
    }
    RemoveOpenerEventListeners() {
        document.removeEventListener('click', this.Click, false);
        document.removeEventListener("keydown", this.Keydown, false);
    }

    Click(event) {
        if (!this.main.classList.contains(this.class.open)) return
        const target = event.target;

        if (target.classList.contains('gtc:overlay') || !target.closest('nested') && this.main.contains(target)) {

            // Closes  if clicked outside of the Modal/drawer, or clicking on data-gtc-close
            if (!this.main.contains(target) || target.hasAttribute('data-gtc-close')) {
                this.Close();
            }
        }
    }

    Keydown(event) {
        // If Esc key
        if (event.keyCode !== 27) return;
        this.Close();
    }

    Open() {
        this.main.classList.add(this.class.open);
        document.body.classList.add(this.class.overlayOpen, this.class.scrollLock);
        setTimeout(() => {
            this.AddOpenerEventListeners();
        }, 0);
    }

    Close() {
        this.main.classList.remove(this.class.open);
        if (!this.classList.contains('nested')) {
            document.body.classList.remove(this.class.overlayOpen, this.class.scrollLock);
        }
        setTimeout(() => {
            this.RemoveOpenerEventListeners();
        }, 0);
    }

    async Content() {

        this.content = {
            header: this.settings.title,
            body: '',
            tabs: '',
            extraLink: '',
            footer: ''
        }

        if (this.settings.content) {
            this.content.body = this.settings.content;
        }
        else if (this.settings.url) {
            this.content.body = await getPageContentHtml(this.settings.url);
        }
        else if (this.settings.section) {
            const canonicalUrl = this.settings.canonicalUrl ? this.settings.canonicalUrl : null;
            this.content.body = await getSectionHtml(this.settings.section, canonicalUrl);
        }

        if (this.settings.tabs) {
            for (const tab of this.settings.tabs) {
                tab.content = await getPageContentHtml(tab.url);
            }
            this.content.tabs = this.settings.tabs;
        }

        if (this.settings.extraLink) {
            this.content.extraLink = this.settings.extraLink;
        }
    }

    async Create() {

        await this.Content();

        const html = this.render({ ...this.content });

        if (!html) return console.warn('No HTML IN GTC-OPENER!');

        if (!gOverlayLoaded) {
            createGOverlay();
        }

        if (this.settings?.class) {
            const classes = this.settings.class.split(' ').filter((letter) => letter !== "");;
            this.classList.add(...classes)
        }

        if (this.settings?.id) {
            this.setAttribute('id', this.settings.id);
        }

        this.main.insertAdjacentHTML('beforeend', html);

        //This forces repaint
        void this.main.offsetHeight;

        this.settings.rendered = true

        this.Open();
        document.addEventListener(`gtc:opener:open.${ this.settings.id }`, () => this.Open());
    }
}

/************************* GTC Modal *************************/
class GTCModal extends GTCOpener {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.hasAttribute('settings')) return;

        this.settings = {
            rendered: false,
            ...JSON.parse(this.getAttribute('settings'))
        };

        //Needs a render to display the content
        switch (this.settings.render) {
            default:
                this.render = renderDefaultModal
                break;
        };

        this.Init();
    }
}

customElements.define('gtc-modal', GTCModal);

/************************* GTC Drawer *************************/

class GTCDrawer extends GTCOpener {

    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.hasAttribute('settings')) return;

        this.settings = {
            rendered: false,
            ...JSON.parse(this.getAttribute('settings'))
        };

        //Needs a render to display the content
        switch (this.settings.render) {
            default:
                this.render = renderDefaultDrawer;
                break;
        };

        this.Init();
    }
}
customElements.define('gtc-drawer', GTCDrawer);

/************************* GTC Trigger *************************/

class GTCTrigger extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        this.Init();
    }

    Init() {
        const settings = this.hasAttribute('settings') ? { ...JSON.parse(this.getAttribute('settings')) } : null;

        if (!settings) return;

        this.settings = {
            ...settings
        };

        this.Click = this.Click.bind(this);
        this.addEventListener('click', this.Click)
    }

    Click() {
        if (!this.hasAttribute('loaded')) {

            switch (this.settings.type) {
                case 'modal':
                    this.CreateCustomElement(this.settings.type)
                    break;
                case 'drawer':
                    this.CreateCustomElement(this.settings.type)
                    break;
                default:
                    console.warn('No opener "type" is matching.');
                    this.setAttribute('disabled', '');
                    break;
            }
            this.setAttribute('loaded', '');
        }
        else {
            document.dispatchEvent(new CustomEvent(`gtc:opener:open.${ this.settings.id }`));
        }
    }

    CreateCustomElement(type) {
        const openerElement = document.createElement(`gtc-${ type }`);
        openerElement.setAttribute('settings', JSON.stringify(this.settings));
        openerElement.classList.add(`gtc:${ type }`);
        document.body.append(openerElement)
    }
}

customElements.define('gtc-trigger', GTCTrigger);